import { render, staticRenderFns } from "./ClusterDetails.vue?vue&type=template&id=37e047a2&scoped=true&"
import script from "./ClusterDetails.vue?vue&type=script&lang=js&"
export * from "./ClusterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClusterDetails.vue?vue&type=style&index=0&id=37e047a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e047a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e047a2')) {
      api.createRecord('37e047a2', component.options)
    } else {
      api.reload('37e047a2', component.options)
    }
    module.hot.accept("./ClusterDetails.vue?vue&type=template&id=37e047a2&scoped=true&", function () {
      api.rerender('37e047a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClusterDetails.vue"
export default component.exports